import ContentMain from 'primitives/Layout/ContentMain';
import styled from '@emotion/styled';

const Container = styled(ContentMain)({ marginBottom: 0 });

export default Container;
